var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _vm._v(_vm._s(_vm.$t("Title_BalanceSheet")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-4" }, [
      _vm.report.balanceSheet
        ? _c("div", [
            _vm.hasProcuration
              ? _c(
                  "div",
                  [
                    _c("plain-text-control", {
                      attrs: {
                        title: "BalanceSheet.Table_Title",
                        required: true,
                        instructionKey: "BalanceSheet.Table_Title_Instructions"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "table",
                      {
                        staticClass: "table tablerow",
                        attrs: {
                          "aria-label": _vm.$t("BalanceSheet.Assets.Title")
                        }
                      },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticClass: "w-85 larger",
                                attrs: { id: "BalanceSheet.Assets_entry" }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("toUpperCase")(
                                        _vm.$t("BalanceSheet.Assets.Title")
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "w-15 right larger",
                                attrs: { id: "BalanceSheet.Assets_euro" }
                              },
                              [_c("span", [_vm._v(_vm._s(_vm.$t("Euro")))])]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _c("table-row", {
                              attrs: {
                                labelledBy: "BalanceSheet.Assets_euro",
                                item: _vm.assets.fixedAssets
                              }
                            }),
                            _vm._v(" "),
                            _c("table-row", {
                              attrs: {
                                labelledBy: "BalanceSheet.Assets_euro",
                                item: _vm.assets.fixedAssets.childItems[0]
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.assets.fixedAssets.childItems[0].childItems,
                              function(childItem) {
                                return _c("table-row", {
                                  key: childItem.name,
                                  attrs: {
                                    labelledBy: "BalanceSheet.Assets_euro",
                                    item: childItem,
                                    required: true
                                  }
                                })
                              }
                            ),
                            _vm._v(" "),
                            _c("table-row", {
                              attrs: {
                                labelledBy: "BalanceSheet.Assets_euro",
                                item: _vm.assets.fixedAssets.childItems[1]
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.assets.fixedAssets.childItems[1].childItems,
                              function(childItem) {
                                return _c("table-row", {
                                  key: childItem.name,
                                  attrs: {
                                    labelledBy: "BalanceSheet.Assets_euro",
                                    item: childItem,
                                    required: true
                                  }
                                })
                              }
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _c("table-row", {
                              attrs: {
                                labelledBy: "BalanceSheet.Assets_euro",
                                item: _vm.assets.reserveFunds,
                                required: true
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _c("table-row", {
                              attrs: {
                                labelledBy: "BalanceSheet.Assets_euro",
                                item: _vm.assets.currentAssets
                              }
                            }),
                            _vm._v(" "),
                            _c("table-row", {
                              attrs: {
                                labelledBy: "BalanceSheet.Assets_euro",
                                item: _vm.assets.currentAssets.childItems[0],
                                showBold: true,
                                required: true
                              }
                            }),
                            _vm._v(" "),
                            _c("table-row", {
                              attrs: {
                                labelledBy: "BalanceSheet.Assets_euro",
                                item: _vm.assets.currentAssets.childItems[1],
                                showBold: true
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.assets.currentAssets.childItems[1].childItems,
                              function(childItem) {
                                return _c("table-row", {
                                  key: childItem.name,
                                  attrs: {
                                    labelledBy: "BalanceSheet.Assets_euro",
                                    item: childItem,
                                    required: true
                                  }
                                })
                              }
                            ),
                            _vm._v(" "),
                            _c("table-row", {
                              attrs: {
                                labelledBy: "BalanceSheet.Assets_euro",
                                item: _vm.assets.currentAssets.childItems[2],
                                showBold: true,
                                required: true
                              }
                            }),
                            _vm._v(" "),
                            _c("table-row", {
                              attrs: {
                                labelledBy: "BalanceSheet.Assets_euro",
                                item: _vm.assets.currentAssets.childItems[3],
                                showBold: true,
                                required: true
                              }
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("tfoot", [
                          _c("tr", [
                            _c(
                              "th",
                              { staticClass: "disabled larger row-heading" },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("BalanceSheet.Assets.Total"))
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "right disabled larger computed-cell"
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(_vm.assets.total)
                                    )
                                  )
                                ])
                              ]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "table",
                      {
                        staticClass: "table tablerow mt-4",
                        attrs: {
                          "aria-label": _vm.$t("BalanceSheet.Liabilities.Title")
                        }
                      },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticClass: "w-85 larger",
                                attrs: { id: "BalanceSheet.Liabilities_entry" }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("toUpperCase")(
                                        _vm.$t("BalanceSheet.Liabilities.Title")
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "w-15 right larger",
                                attrs: { id: "BalanceSheet.Liabilities_euro" }
                              },
                              [_c("span", [_vm._v(_vm._s(_vm.$t("Euro")))])]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _c("table-row", {
                              attrs: {
                                labelledBy: "BalanceSheet.Liabilities_euro",
                                item: _vm.liabilities.capitalAndReserves
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.liabilities.capitalAndReserves.childItems,
                              function(item) {
                                return _c("table-row", {
                                  key: item.name,
                                  attrs: {
                                    labelledBy: "BalanceSheet.Liabilities_euro",
                                    item: item,
                                    required: true
                                  }
                                })
                              }
                            ),
                            _vm._v(" "),
                            _c("table-row", {
                              attrs: {
                                labelledBy: "BalanceSheet.Liabilities_euro",
                                item: _vm.liabilities.provisions,
                                required: true
                              }
                            }),
                            _vm._v(" "),
                            _c("table-row", {
                              attrs: {
                                labelledBy: "BalanceSheet.Liabilities_euro",
                                item: _vm.liabilities.creditors
                              }
                            }),
                            _vm._v(" "),
                            _c("table-row", {
                              attrs: {
                                labelledBy: "BalanceSheet.Liabilities_euro",
                                item: _vm.liabilities.creditors.childItems[0],
                                showBold: true,
                                required: true
                              }
                            }),
                            _vm._v(" "),
                            _c("table-row", {
                              attrs: {
                                labelledBy: "BalanceSheet.Liabilities_euro",
                                item: _vm.liabilities.creditors.childItems[1],
                                showBold: true
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.liabilities.creditors.childItems[1]
                                .childItems,
                              function(childItem) {
                                return _c("table-row", {
                                  key: childItem.name,
                                  attrs: {
                                    labelledBy: "BalanceSheet.Liabilities_euro",
                                    item: childItem,
                                    required: true
                                  }
                                })
                              }
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("tfoot", [
                          _c("tr", [
                            _c(
                              "th",
                              { staticClass: "disabled larger row-heading" },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("BalanceSheet.Liabilities.Total")
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "right disabled larger computed-cell"
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        _vm.liabilities.total
                                      )
                                    )
                                  )
                                ])
                              ]
                            )
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _c("div", [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("ProcurationOnly", {
                          title: _vm.$t("Title_BalanceSheet")
                        })
                      )
                    )
                  ])
                ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }